/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { DataStateItem, DataValue, EFieldType } from 'shared/types';
import { IFieldMeta } from 'shared/types/Page.interface';
import { BadgedLabel } from 'shared/ui/BadgedLabel';
import { CalculateField } from 'shared/ui/CalculateField';
import { DatePreferenceField, DatePrefValue } from 'shared/ui/DatePreferenceField';
import { DateTimeField } from 'shared/ui/DateTimeField';
import { PicklistField } from 'shared/ui/PicklistFIeld';
import { Select } from 'shared/ui/Select';
import { TagsField } from 'shared/ui/TagsField';
import { TemplateField } from 'shared/ui/TemplateField';

interface ColumnCellProps {
  record: DataStateItem
  value: DataValue
  columnMeta: IFieldMeta
}

export const TableColumnCell: React.FC<ColumnCellProps> = React.memo((props) => {
  const {
    record, value, columnMeta,
  } = props;
  const fieldType = columnMeta.type;

  switch (fieldType) {
  case EFieldType.input:
    return <div>{value as string}</div>;
  case EFieldType.calculate:
    return <CalculateField columnMeta={columnMeta} record={record} value={value} />;
  case EFieldType.colored:
    return (
      <BadgedLabel
        statusColorMap={columnMeta.colorMap}
        value={value as string}
        selectOptions={columnMeta.selectOptions}
      />
    );
  case EFieldType.template:
    return <TemplateField fieldKeys={columnMeta.keys} record={record} drillDown={columnMeta.drilldown} />;
  case EFieldType.select:
    return <Select options={columnMeta.options} value={value as string} readonly />;
  case EFieldType.tags:
    return (
      <TagsField
        value={value as any}
        deepObject={columnMeta.deepObject}
        dateFormat={columnMeta.dateFormat}
        display={columnMeta.display}
      />
    );
  case EFieldType.dateTime:
    return (
      <DateTimeField
        value={value as string}
        sourceFormat={columnMeta.sourceFormat}
        targetFormat={columnMeta.targetFormat}
      />
    );
  case EFieldType.datePref:
    return (
      <DatePreferenceField
        value={value as DatePrefValue[]}
        sourceFormat={columnMeta.sourceFormat}
        targetFormat={columnMeta.targetFormat}
        datePreference={columnMeta.datePreference}
        mapKey={columnMeta.key}
        map={columnMeta.map}
      />
    );
  case EFieldType.picklist:
    return <PicklistField value={value} pickMap={columnMeta.pickMap} />;
  default:
    return <div>{value as string}</div>;
  }
});
